import React from 'react';

const LoginCard = ({ children }) => {
  return (
    <div className="relative z-10 w-full max-w-md mx-auto">
      {/* Main Card */}
      <div className="bg-card/95 backdrop-blur-sm border border-border rounded-2xl shadow-elevated p-8">
        {children}
      </div>
      {/* Security Badge */}
      <div className="mt-6 text-center">
        <div className="inline-flex items-center space-x-2 px-3 py-2 bg-success/10 border border-success/20 rounded-full">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span className="text-xs text-success font-medium">Sichere Verbindung</span>
        </div>
      </div>
      {/* Footer Info */}
      <div className="mt-8 text-center space-y-2">
        <p className="text-xs text-muted-foreground">
          © {new Date()?.getFullYear()} Ragna Detailing. Alle Rechte vorbehalten.
        </p>
      </div>
    </div>
  );
};

export default LoginCard;
